import { Component, Input, OnInit } from '@angular/core';
import { StarlyToast, StarlyToastService } from '../../../services/starly-toast.service';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';

@Component({
  standalone: true,
  imports: [CommonModule, IonicModule],
  selector: 'app-starly-toast',
  templateUrl: './starly-toast.component.html',
  styleUrls: ['./starly-toast.component.scss'],
})
export class StarlyToastComponent implements OnInit {
  public toast: StarlyToast | null = null;

  constructor(private starlyToastService: StarlyToastService) {
    this.starlyToastService.currentToast$.subscribe((toast) => {
      this.toast = toast;
    });
  }

  ngOnInit() {}
}
